import { PopoverMenu, TextButton } from '@wix/design-system';
import type { RicosContent } from '@wix/ricos';
import { ChevronDown } from '@wix/wix-ui-icons-common';
import React from 'react';

import type { ContentHistory } from './use-document-history';

const getSubtitle = type => {
  switch (type) {
    case 'ai-prompt':
      return 'AI Prompt';
    case 'editor':
      return 'Editor';
    case 'code-editor':
      return 'Code Editor';
    case 'auto-fix':
      return 'Auto Fix';
    default:
      return '';
  }
};

interface DocumentHistoryProps {
  contentHistory: ContentHistory;
  setContent(content: RicosContent): void;
}

const DocumentHistory: React.FC<DocumentHistoryProps> = ({ contentHistory, setContent }) => {
  return (
    <PopoverMenu
      minWidth="240px"
      maxHeight="240px"
      textSize="small"
      triggerElement={<TextButton suffixIcon={<ChevronDown />}>Revision</TextButton>}
    >
      {contentHistory.map(({ content, version, metadata }) => (
        <PopoverMenu.MenuItem
          key={version}
          text={version}
          subtitle={getSubtitle(metadata?.type)}
          onClick={() => setContent(content as RicosContent)}
        />
      ))}
    </PopoverMenu>
  );
};

export default DocumentHistory;
